import { get } from 'lodash';

import { FIELD_PATHS, FIELD_VALUES } from '@funnels/constants';
import { FormValues, StoreApplicant } from '@funnels/types';

import { Panel, PanelHeading } from '../_common/style';
import {
  ConstructionLoanLayout,
  NewPurchaseLayout,
  NonPersonApplicantLayout,
  PreapprovalLayout,
  RefinanceLayout,
} from './layouts';

export interface ApplicantsPanelProps {
  layout: FIELD_VALUES;
  currentValues: FormValues;
}

const ApplicantsPanel = (props: ApplicantsPanelProps) => {
  const getLayoutForPerson = (applicant: StoreApplicant, index: number) => {
    switch (props.layout) {
      case FIELD_VALUES.CONSTRUCTION_LOAN:
        return (
          <ConstructionLoanLayout
            key={`readonly-construction-${applicant.clientId}`}
            index={index}
            currentValues={props.currentValues}
          />
        );
      case FIELD_VALUES.NEW_PURCHASE:
        return (
          <NewPurchaseLayout
            key={`readonly-newPurchase-${applicant.clientId}`}
            index={index}
            currentValues={props.currentValues}
          />
        );
      case FIELD_VALUES.PREAPPROVAL:
        return (
          <PreapprovalLayout
            key={`readonly-preapproval-${applicant.clientId}`}
            index={index}
            currentValues={props.currentValues}
          />
        );
      case FIELD_VALUES.REFINANCE:
        return (
          <RefinanceLayout
            key={`readonly-refinance-${applicant.clientId}`}
            index={index}
            currentValues={props.currentValues}
          />
        );
      default:
        return null;
    }
  };

  const getLayout = (applicant: StoreApplicant, index: number) => {
    const applicantEntity = get({ applicants: [applicant] }, FIELD_PATHS.APPLICANT_ENTITY(0));

    if (applicantEntity === FIELD_VALUES.PERSON) {
      return getLayoutForPerson(applicant, index);
    } else if ([FIELD_VALUES.TRUST, FIELD_VALUES.COMPANY].includes(applicantEntity)) {
      const trustName = get({ applicants: [applicant] }, FIELD_PATHS.APPLICANT_TRUST_NAME(0));
      const companyName = get({ applicants: [applicant] }, FIELD_PATHS.APPLICANT_COMPANY_NAME(0));

      return (
        <NonPersonApplicantLayout
          applicantName={trustName ?? companyName ?? `Applicant ${index + 1}`}
          applicantEntity={applicantEntity}
          applicantIndex={index}
        />
      );
    } else {
      return null;
    }
  };

  return (
    <Panel>
      <PanelHeading>{`Applicants (${props.currentValues.applicants.length})`}</PanelHeading>
      {props.currentValues.applicants.map((applicant, index) => getLayout(applicant, index))}
    </Panel>
  );
};

export default ApplicantsPanel;
